<script setup lang="ts">
import { useRouter } from 'vue-router'

import MapHeader from '@/components/MapHeader.vue'
import AboutPageOverlay from '@/components/static/AboutPageOverlay.vue'
import { resolveSitePagePath } from '@/services/sitePageRouteService'

const router = useRouter()

const openStaticSite = (pageId: string) => {
  void router.push(resolveSitePagePath(pageId))
}
</script>

<template>
  <div class="h-screen overflow-hidden bg-[#FEFEFE]">
    <MapHeader />
    <AboutPageOverlay :is-open="true" @open-static-site="openStaticSite" />
  </div>
</template>
